import React from 'react'

const LiveGames = () => {
  return (
    <div>LiveGames</div>
  )
}

export default LiveGames